export default "__VITE_ASSET__0e5a41db__"